// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"51e8551f","112":"aa10d9f2","207":"514ee8cc","228":"793e2a6e","308":"20458ec2","438":"80410974","453":"39edb0bf","669":"8e55bbe6","739":"7a7b836c"}[chunkId] + ".chunk.js";
};